import React, {Fragment} from "react";

import HookSubFormCarer from "root/Base/HookFormComponents/ChildPeople/HookSubFormCarer";
import HookSubFormSocialWorker from "root/Base/HookFormComponents/ChildPeople/HookSubFormSocialWorker";
import HookSubFormIRO from "root/Base/HookFormComponents/ChildPeople/HookSubFormIRO";
import HookSubFormESW from "root/Base/HookFormComponents/ChildPeople/HookSubFormESW";
import HookSubFormEdPsych from "root/Base/HookFormComponents/ChildPeople/HookSubFormEdPsych";
import HookSubFormSchool from "root/Base/HookFormComponents/ChildPeople/HookSubFormSchool";

const HookFormGroupChildPeople = ({control, register, watch, reset, formErrors, readOnly, setValue, formMode}) =>
{
    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
        readOnly: readOnly,
        setValue: setValue,
        reset: reset,
    }

    return (
        <Fragment>
            <HookSubFormCarer { ...controlProps } sectionName='carer'/>
            <HookSubFormSocialWorker { ...controlProps } sectionName='social_worker'/>
            <HookSubFormIRO { ...controlProps } sectionName='iro'/>
            <HookSubFormESW { ...controlProps } sectionName='esw'/>
            <HookSubFormEdPsych { ...controlProps } sectionName='ed_psych'/>
            <HookSubFormSchool { ...controlProps } sectionName='school'/>
        </Fragment>
    )
}

export default HookFormGroupChildPeople ;